import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import useThemeClass from 'utils/hooks/useThemeClass'

const Breadcrumb = ({ items }) => {
    const navigate = useNavigate()
    const { textTheme, borderTheme } = useThemeClass()

    const handleClick = (href) => {
        navigate(href)
    }

    return (
        <nav className="flex items-center text-gray-500 text-sm">
            {items.map((item, index) => (
                <div key={index} className="flex items-center">
                    {index > 0 && <span className="mx-2">/</span>}
                    {item.href ? (
                        <div
                            onClick={() => handleClick(item.href)}
                            className={`hover:${textTheme} hover:font-medium hover:rounded-md cursor-pointer text-gray-600`}
                        >
                            {item.label}
                        </div>
                    ) : (
                        <span
                            className={classNames(
                                'font-medium text-black',
                                !!item?.onClick &&
                                    `cursor-pointer text-gray-600 hover:${textTheme}`
                            )}
                            onClick={() => item?.onClick?.()}
                        >
                            {item.label}
                        </span>
                    )}
                </div>
            ))}
        </nav>
    )
}

export default Breadcrumb
